import request from '@/utils/request'

const baseUrl = '/erp/sales/report/customer-sales-detail'

export const pageCustomerSalesDetailReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const listCustomerSalesDetailSupplierOptions = () => request({
  url: baseUrl + '/supplier-options',
  method: 'get'
})

export const exportCustomerSalesDetailReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
